<template>

  <Popover>

    <PopoverButton ref="reference" class="flex justify-center items-center rounded-md h-10 w-fit px-4 ring-1 ring-black/20 gap-2 focus-within hover-button">
      <span>Berufe</span>
      <span v-show="selectedJobs.length" class="text-sm text-black/60">{{ selectedJobs.length }}</span>
     </PopoverButton>

      <PopupTransition>
        <teleport to="body">
          <PopoverPanel
              ref="floating"
              class="fixed z-[3000] p-4 glass-background w-[600px] h-fit rounded-md"
              :style="floatingStyles">

            <div class="flex justify-between items-center">
              <h3 class="popup-title">Ausbildungsberufe</h3>
              <button class="text-sm text-black/60 hover:text-black" @click="jobs.map(job => job.isSelected=false)">Zurücksetzen</button>
            </div>

            <div class="flex flex-wrap gap-3">
              <button @click="onJobClick(job)" class="normalText p-2 ring-1 ring-black/20 rounded-md hover-button" :class="job.isSelected ? 'ring-0 bg-[#E1A325] hover:bg-[#CF9120]\n ring-[#F0B64B]' : ''" v-for="job in jobs" :key="job.title">{{job.title}}</button>
            </div>


          </PopoverPanel>
        </teleport>
      </PopupTransition>

  </Popover>

</template>

<script setup>
import { Popover, PopoverButton, PopoverPanel} from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import {FunnelIcon} from "@heroicons/vue/24/outline";
import { useFloating, offset, flip, shift } from '@floating-ui/vue'
import {computed, ref, defineProps, watch, defineEmits } from "vue";
import { autoUpdate } from '@floating-ui/vue'
import PopupTransition from "@/components/ui/PopupTransition.vue";

defineProps({
  preselectedJobs: { type: Array, default: () => [] },
})

const emit = defineEmits(['update:modelValue'])

const reference = ref(null)
const floating = ref(null);
const { floatingStyles } = useFloating(reference, floating, {
  placement: 'bottom',
  middleware: [
    offset(8),
    flip(),
    shift({ padding: 8 }),
  ],
  whileElementsMounted: autoUpdate,
})

const jobs = ref([
  {
    id: 1,
    title: "Hotelfachmann-/frau (m/w/d)",
    imgPath: "img/jobs/hotelfachmann.jpg",
    isSelected: false
  },
  {
    id: 2,
    title: "Kaufmann-/frau für Hotelmanagement (m/w/d)",
    imgPath: "img/jobs/hotelmanagement.jpg",
    isSelected: false
  },
  {
    id: 3,
    title: "Koch/Köchin (m/w/d)",
    imgPath: "img/jobs/koch.jpg",
    isSelected: false
  },
  {
    id: 4,
    title: "Fachmann/-frau für Systemgastronomie (m/w/d)",
    imgPath: "img/jobs/fachkraft_system_gastronomie.jpg",
    isSelected: false
  },
  {
    id: 5,
    title: "Fachkraft für Gastronomie (m/w/d)",
    imgPath: "img/jobs/fachkraft_gastronomie.jpg",
    isSelected: false
  },
  {
    id: 6,
    title: "Fachkraft Küche (m/w/d)",
    imgPath: "img/jobs/fachkraft_küche.jpg",
    isSelected: false
  },
  {
    id: 7,
    title: "Fachmann-/frau für Restaurants und Veranstaltungsgastronomie (m/w/d)",
    imgPath: "img/jobs/veranstaltungsgastronomie.jpg",
    isSelected: false
  }
]);
const onJobClick = (job) => {
  job.isSelected = !job.isSelected;
};

const selectedJobs = computed(() => {
  return jobs.value.filter(job => job.isSelected).map(job => job.title);
})

watch(() => selectedJobs.value, (newValue) => {
  console.log("selectedJobs", newValue)
  emit('update:modelValue', newValue)
}, { immediate: true });

</script>
